// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".picker__container {\n  width: 260px;\n  display: flex;\n  height: 26px;\n  margin-bottom: 6px;\n  position: relative;\n}\n\n.color__picker {\n  z-index: 100;\n  position: absolute;\n  left: 270px;\n  height: auto;\n  width: auto;\n}\n.picker__text {\n  width: 180px;\n}\n.picker__color {\n  width: 80px;\n  cursor: pointer;\n  position: relative;\n}\n", ""]);
// Exports
module.exports = exports;
